const TYPE_ONE_BENEFITS = [
    { value: 'UNIFORM', label: 'Uniforme' },
    { value: 'TRANSPORT', label: 'Transporte' },
    { value: 'FOOD', label: 'Alimentação' },
    { value: 'HOUSING', label: 'Moradia' },
    { value: 'STUDY_MATERIAL', label: 'Material Didático' },
];

export default TYPE_ONE_BENEFITS